import * as accountsApi from '@/network/api/accounts.api.js'
import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as cardsCreditApi from '@/network/api/cards/credit.api.js'
import * as exchangeApi from '@/network/api/exchange.api.js'
import * as favoritesApi from '@/network/api/favorites.api.js'

/** Request Accounts Balances
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
@return {promise} - Accounts Balances
*/
export const requestAccountsBalances = async (context, payload) => {
	const res = await accountsApi.requestAccountsBalances(payload)

	if (res) context.commit('SAVE_ACCOUNTS_BALANCE', res.data.data)
	return res
}

/** requests Cards List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
	const res = await cardsApi.cards(payload)

	if (res) context.commit('SAVE_CARDS', res.data.data)
	return res
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cards%7BcardNumber%7DavailableTopupPlafond
@return {promise} - Available Plafond
*/
export const getAvailableTopupPlafond = async (context, payload) => {
    const res = await cardsApi.getAvailableTopupPlafond(payload)

    if (res) context.commit('SAVE_PLAFOND', res.data.data)
    return res
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchange
@return {promise} - Conversor Exchange
*/
export const exchangeAmount = async (context, payload) => {
    const res = await exchangeApi.exchangeAmount(payload)

    if (res) context.commit('SAVE_EXCHANGE', res.data.data)
    return res
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cardscredit%7Bid%7Dtopup
@return {promise} - Charge Virtual Card
*/
export const chargeCreditCard = async (context, payload) => {
    const res = await cardsCreditApi.chargeCreditCard(payload)

    return res
}

/** request topups list
@docs no docs
*/
export const requestLastChargesList = async (context, payload) => {
	const res = await cardsApi.getTopupsList(payload)

	if (res) context.commit('SAVE_LAST_CHARGES', res.data)
	return res
}

/** requests Favorites List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
@return {promise} - Favorites List
*/
export const requestFavoritesList = async (context, payload) => {
	const res = await favoritesApi.getFavoritesList(payload)

	if (res) {
		const data = res.data.data
		context.commit('SAVE_FAVORITES_LIST', { pageNumber: payload.pageNumber, data: data })
	}
	return res
}

/** Charge Card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cards%7BcardNumber%7Dtopup
@return {promise}
*/
export const chargeCard = async (context, payload) => {
	const res = await cardsApi.chargeCard(payload)
	return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
